import { createClientRepos } from '@poppy/firebase';
import { db } from './firebase';

export const repos = createClientRepos(db);

export default repos;
